import { useState, Fragment } from 'react';
import { Avatar, CircularProgress } from '@material-ui/core';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import { useQuery, useMutation } from 'react-query';
import { getImage, uploadImage } from 'src/services/images.services';
import UploadImageDialog from './UploadImageDialog';
import { queryClient } from 'src';
import PropTypes from 'prop-types';
import { snackbarAtom } from 'src/atoms/snackbar';
import { useRecoilState } from 'recoil';
const BeneficiaryImage = ({ beneficiary }) => {
  const [hover, setHover] = useState(false);
  const [noPic, setNoPic] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [imageKey, setImageKey] = useState(beneficiary?.profile_picture);
  const [, setSnackbar] = useRecoilState(snackbarAtom);
  const refetch = async (newUrl) => {
    setImageKey(newUrl);
    queryClient.removeQueries(['beneficiaryImage', beneficiary.id]);
    queryClient.setQueryData(['beneficiaryImage', beneficiary.id], newUrl);
  };

  const { mutate, isLoading: uploadImageLoading } = useMutation(
    async (formData) =>
      await uploadImage(`/beneficiaries/${beneficiary.id}/profile_picture`, formData),
    {
      onSuccess: async (data) => {
        queryClient.invalidateQueries(['beneficiaryImage', beneficiary.id]);
        refetch(data.profile_picture);
        setDialogOpen(false);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          message: error?.message || 'Something went wrong',
          severity: 'error'
        });
      }
    }
  );

  const handleUploadImage = async (image) => {
    if (!image) return;
    const formData = new FormData();
    formData.append('profile_picture', image);
    mutate(formData);
  };

  const {
    data: beneficiaryImage,
    loading: beneficiaryImageLoading,
    isFetching
  } = useQuery(
    ['beneficiaryImage', beneficiary.id],
    async () => {
      if (beneficiary.profile_picture === '' || beneficiary.profile_picture === null) {
        setNoPic(true);
        return;
      }
      return await getImage(imageKey);
    },
    {
      enabled: !!beneficiary,
      cacheTime: 0,
      refetchOnWindowFocus: false
    }
  );

  return (
    <Fragment>
      <UploadImageDialog
        open={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        handleUploadImage={handleUploadImage}
        loading={uploadImageLoading}
        src={beneficiaryImage}
      />
      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          cursor: 'pointer',
          borderRadius: '50%'
        }}
        onClick={() => setDialogOpen(true)}
      >
        <div
          style={{
            position: 'relative ',
            width: '35px',
            height: '35px'
          }}
        >
          {hover && (
            //overlay
            <div>
              <div
                style={{
                  position: 'absolute',
                  width: '35px',
                  top: '0',
                  left: '0',
                  height: '35px',
                  borderRadius: '50%',
                  backgroundColor: 'black',
                  opacity: '0.5',
                  zIndex: '100'
                }}
              />
              <EditRoundedIcon
                style={{
                  color: 'white',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: '101',
                  opacity: '1'
                }}
              />
            </div>
          )}
          <div
            style={{
              width: '35px',
              height: '35px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {uploadImageLoading ||
            beneficiaryImageLoading ||
            (!beneficiaryImage && !noPic) ||
            isFetching ? (
              <CircularProgress color="incorta" size={20} />
            ) : (
              <Avatar
                src={beneficiaryImage}
                variant="circular"
                style={{ width: '35px', height: '35px' }}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

BeneficiaryImage.propTypes = {
  beneficiary: PropTypes.object.isRequired
};

export default BeneficiaryImage;
